import { Toolbar, Button, Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const LogoImage = styled("img")({
  maxWidth: "100%",
  height: "45px",
});

const Toolbarstyles = {
  root: {
    minHeight: "inherit !important",
  },
};
const SignUpButton = styled(Button)(({ theme }) => ({
  "&.MuiButton-root": {
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    fontFamily: theme.typography.fontFamily,
    background: theme.palette.background.white,
    textTransform: "capitalize",
    borderRadius: "32px",
    color: theme.palette.colors.BlackBean,
    marginLeft: "15px",
  },
  "&.MuiButton-root:hover": {
    background: theme.palette.background.whiteHover,
    color: theme.palette.colors.BlackBean,
  },
}));

const DeskTopLink = styled(Box)(({ theme }) => ({
  gap: "25px",
  width: "80%",
  alignItems: "center",
  justifyContent: "center",
  "& a": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "25px",
    textAlign: "center",
    color: "rgba(11, 11, 11, 0.5)",
    fontFamily: theme.typography.fontFamily,
    textDecoration: "none",
    "&.active_link": {
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "18px",
      lineHeight: "25px",
      textAlign: "center",
      textDecorationLine: "underline",
      color: "#0B0B0B",
    },
  },
}));
const LogoMain = styled(Box)(({ theme }) => ({
  width: "10%",
}));
const AuthButtonMain = styled(Box)(({ theme }) => ({
  width: "10%",
  textAlign: "center",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "10px",
}));
const ToolbarMain = styled(Toolbar)(({ theme }) => ({
  justifyContent: "space-between",
}));
const NotificationBTn = styled(Button)(({ theme }) => ({
  background: "transparent",
  boxShadow: "none",
  padding: "0px",
  minWidth: "auto",
  "&:hover": { background: "transparent", boxShadow: "none", padding: "0px" },
}));

export {
  LogoImage,
  Toolbarstyles,
  SignUpButton,
  DeskTopLink,
  LogoMain,
  AuthButtonMain,
  ToolbarMain,
  NotificationBTn,
};
